import Image from "./Image"
// import DynamicImage from "./DynamicImage"

// Image.Dynamic = DynamicImage

export default Image
